import React from 'react';

import classNames from 'classnames';
import ButtonRibbon from '../_utils/button-ribbon';
import sendToGoogleAnalytics from '../_prism-builder/desktop/slot-tools/send-to-google-analytics';

const LoaderNav = props => {
  const serviceTitle = {
    upload: props.isMobile ? 'My Phone' : 'My Computer',
    mobile: 'My Phone',
    albums: `My ${window.store} Photos`,
    picasa: 'Google Photos',
    facebook: 'Facebook',
    dropbox: 'Dropbox',
    instagram: 'Instagram',
    flickr: 'Flickr',
  };

  const handleClick = service => {
    sendToGoogleAnalytics('loader-nav', `${serviceTitle[service]}`);
  };

  return (
    <ButtonRibbon className="loader-nav" role="tablist" loaderNav>
      {props.imgSources.map(({ service, title }, index) => {
        const selected = props.activeSource === index;
        return (
          <button
            aria-controls={'image-loader-service-' + service}
            aria-label={`${serviceTitle[service]}`}
            aria-selected={selected}
            className={classNames('service', service, { active: selected })}
            key={service}
            role="tab"
            type="button"
            onClick={() => {
              props.onSourceSelect(index, service);
              handleClick(service);
            }}>
            {serviceTitle[service]}
          </button>
        );
      })}
    </ButtonRibbon>
  );
};

export default LoaderNav;
